import { useSharedChannelValidations, type IChannelValidations } from '@gem/modules/validations';

import { channelAliasAsyncValidation } from '../fields/channelAliasAsyncValidation';

export const useChannelValidations = (): IChannelValidations => {
  return useSharedChannelValidations({
    channelAliasAsyncValidation,
  });
};
